/**
 * Google Analytics, production only.
 *
 * Lived as an inline <script> in index.html until 2026-09-15; it moved here so the page's Content
 * Security Policy never has to allow inline scripts (`script-src 'unsafe-inline'`), which is the
 * setting that makes a CSP nearly useless against XSS.
 *
 * Guarded by hostname so localhost, the webpack dev server, Playwright/CI and staging (nirvana)
 * never send pageviews to the live property — that noise is what inflated the numbers before.
 */

const MEASUREMENT_ID = 'G-DK45E3BKS0';
const PRODUCTION_HOSTS = ['imageslicer.com', 'www.imageslicer.com'];

/** Load GA for production hosts only. Returns true when it was installed (used by the spec). */
export function installAnalytics(hostname: string = window.location.hostname): boolean {
  if (!PRODUCTION_HOSTS.includes(hostname)) return false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  // GA's own snippet shape: `arguments` (not an array) is what gtag.js expects.
  function gtag(...args: unknown[]): void {
    w.dataLayer.push(arguments);
  }
  w.gtag = w.gtag || gtag;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', MEASUREMENT_ID);
  return true;
}
